// A coluna DATE chega sem horario; a exibicao nao deve aplicar conversao de fuso.
export const formatCertificateDate = (value) => String(value || "").split("-").reverse().join("/");
